import { DialogTabs } from "../../Shared/components/ItemDetail/ItemDetail-types";
import { CartSelectionModeType, DefaultDaySectionExpansionType, RecipeDisplayNameType, } from "../../Shared/components/OrderSummary/OrderSummary.request";
import { HeaderContentOptions } from "../../Shared/sharedTypes/ConfigurationTypes";
import { PaymentMethodType } from "../../MealTrack/MTAPITypes";
export var DefaultModelEnums;
(function (DefaultModelEnums) {
    DefaultModelEnums["SelectedMealsChipText"] = "Selected Meals";
})(DefaultModelEnums || (DefaultModelEnums = {}));
export const DEFAULT_MODEL = {
    OmissionConfig: {
        OmissionsToDisplay: [],
        OmissionImagesBaseUrl: "",
    },
    BlobRoot: "",
    //TODO: Branding can be removed from Order Flow once its fully implemented in the Company Provider
    Branding: {
        BrandDisplayName: { Input: "" },
        BrandEmail: { Input: "" },
        BrandLogo: { FileUpload: "", IsWhite: false },
        BrandURL: { Input: "" },
        OrderFlowMyMealsCartIcon: { FileUpload: "", IsWhite: false },
        SiteBodyBg: { Color: "" },
    },
    ProductAndRecipeCardLayoutSettings: {
        AdditionalInfoBtnText: "",
        RecipeImageDisplayMode: 0,
        ProductImageDisplayMode: 0,
        companyID: "0",
        DescriptionLineHeight: 0,
        DescriptionLines: 0,
        DisplayAdditionalInfoBtn: false,
        DisplayDescription: false,
        DisplayNameType: 10,
        DisplayPrice: false,
        DisplayRecipeTypes: false,
        DisplaySubscriptionToggle: false,
        ImageHeight: 0,
        RecipeTitleLinesDesktop: 2,
        RecipeTitleLinesMobile: 2,
        SKU: "",
        DisplayOnMobile: 0,
        DisplaySymbolFlags: true,
        DisplayRecipeCompatibilitySymbols: false,
        IngredientsHeading: "",
        AdjustmentsHeading: "",
        RecipeCustomizationAdvisoryText: "",
        DisplayRecipeDescription: true,
        NutritionTabTitle: DialogTabs.NUTRITION,
        CustomizationTabTitle: "",
        CustomizationsHeading: "",
        CustomizationsDialogTitle: "",
        CustomizationsOptionsSubtext: "",
    },
    IsEditFlow: false,
    MealSizes: [],
    Program: { Id: 0, Name: "", Sku: "", ProgramMeals: [], UsesLocation: false },
    SubscriptionMeals: [],
    CultureInfo: "",
    Currency: "",
    ProductImageBaseUrl: "",
    Keys: [],
    Sku: "",
    CompanyUsesKlaviyo: false,
    DateChangesTakeEffect: "",
    DeliveryDays: [],
    DeliveryScheduleMealDays: [],
    DeliverySchedule: [],
    RecipeTypes: [],
    RecipeTypeImageBaseUrl: "",
    SubscriptionDeliveryScheduleId: null,
    SubscriptionProgramId: null,
    CartSettings: {
        CartDetailSectionHeading: "Meal(s)",
        ProductSectionHeading: "Product(s)",
        CartSelectionMode: CartSelectionModeType.NONE,
        companyID: undefined,
        CouponTextDisplay: "",
        DefaultDaySectionExpansion: DefaultDaySectionExpansionType.EXPANDED,
        DeliveryMethodDisplayText: "",
        DeliveryTextDisplay: "",
        DisplayDayPrices: false,
        DisplayDeliveryMethod: false,
        DisplayDiscountedPricePerMeal: false,
        DisplayLocation: false,
        DisplayMealPrices: false,
        DisplayMealSize: false,
        DisplayOmissions: false,
        DisplayPlanName: false,
        DisplayRecipes: false,
        DisplayRecipeType: false,
        DisplayRenewalPeriod: false,
        DisplayShortWeekIndicatorForMeals: false,
        DisplayShortWeekIndicatorForProducts: false,
        DisplaySimplifiedPricingBreakdown: false,
        DisplayStartDate: false,
        DisplaySubscriptionDiscount: false,
        DisplaySubscriptionSection: false,
        EnableDisplayOfQuantitySelectedText: true,
        MealDiscountTextDisplay: "",
        MealSizeDisplayText: "",
        NextOrderSubtotalDisplayText: "",
        NoBalanceDueMessage: "",
        OmissionsDisplayText: "",
        PickupLocationDisplayText: "",
        PlanNameDisplayText: "",
        PostalCodeDisplayText: "",
        PricingTextDisplay: "",
        RecipeDisplayNameType: RecipeDisplayNameType.SHORT_NAME,
        RecipeTypeDisplayText: "",
        ShortWeekIndicatorForMealsText: "",
        ShortWeekIndicatorForProductsText: "",
        SKU: undefined,
        StartDateDisplayText: "",
        SubscriptionDiscountTextDisplay: "",
        SubscriptionSectionDisplayText: "",
        SubtotalTextDisplay: "",
        SurchargeTextDisplay: "",
        TaxTextDisplay: "",
        TotalTextDisplay: "",
        UnselectedRecipeText: "",
        EmptyCartDisplayMessage: "",
        DisplayContinueButton: false,
    },
    PostalCode: "",
    Location: {
        address1: "",
        address2: "",
        city: "",
        country: "",
        locationProgramIds: [-1],
        locationSeq: "-1",
        locationSku: "",
        name: "",
        phone: "",
        state: "",
        zip: "",
        code: "",
        contact: "",
        deliveryFee: 0,
        email: "",
        LocationTaxRate: 0,
        LocationId: "",
        deliveryScheduleID: undefined,
        addressId: 0,
    },
    subscriptionDiscount: 0,
    RecipeFetchStatus: { error: false, completed: false },
    MealSelectionStatus: { completed: false },
    Products: [],
    Recipes: [],
    allMealSizeOption: "",
    recipeTypeSelectionMode: 0,
    recipeModuleAddMeals: false,
    recipeModuleAssignToExisting: false,
    recipeSelectionMissingMealsMessage: "",
    recipeSelectionWarningMessage: "",
    recipeSelectionWarningTitle: "",
    RecipeImageBaseUrl: "",
    MealBundleImageBaseUrl: "",
    UploadedImagesUrl: "",
    ProgramMealImageBaseUrl: "",
    Flow: {
        Id: 0,
        Name: "",
        isDraft: false,
        ProgramId: 0,
        FlowModules: [],
    },
    SkipPayment: false,
    PinNavButton: false,
    dayFilterDays: [],
    OrderFlowDefaults: {
        IsSubscription: false,
        MealSize: {
            CompanyId: 0,
            RecipeSizeId: 0,
            Size: "",
        },
        RecipeType: "",
        StartDate: "",
    },
    OrderFlowSettings: {
        OverLappingOrdersMode: 0,
        PinNavButtons: false,
        RejectMessage: "",
        RejectTitle: "",
        RecipeIngredientReplacementMode: 0,
        SkipLocationPage: false,
    },
    SavedCart: {
        CartGuid: "",
        CartJson: "",
        ExpiresOn: "",
    },
    StartSunday: false,
    SubscriptionProducts: [],
    SubscriptionRecipeType: {
        alternaltiveRecipeTypeIds: null,
        defaultImage: "",
        description: "",
        recipeTypeId: 0,
        recipeTypeName: "",
        recipeTypePrice: 0,
        recipeTypeShortName: "",
        sequence: 0,
        isAllRecipeType: false,
    },
    requirements: [],
    GeneralSettings: {
        OnlyShowDeliveryDays: false,
        UseTopBar: false,
        TopBarBackgroundColor: "#fff",
        TopBarContentOrderFlow: "",
        TopBarContentGiftCard: "",
        HeaderContentOrderFlow: HeaderContentOptions.Navigation,
        HeaderContentGiftCard: HeaderContentOptions.Navigation,
        AlwaysPromptCustomizeMealModal: false,
    },
    SubscriptionSummaryHeaderText: "",
    SubscriptionOrderUpdateAdvisoryNote: "",
    UpdateOrdersConfirmationText: "",
    SymbolFlags: [],
    ExplodeOMDD: true,
    SelectedMealsChipText: DefaultModelEnums.SelectedMealsChipText,
    PaymentMethodType: PaymentMethodType.Unknown
};
